var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 23579",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 69",
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20102"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16981",
    d: "m14.221 10.333-1.965-1.965a1.307 1.307 0 0 0-2.175.491 1.337 1.337 0 0 1-1.544.841 6.059 6.059 0 0 1-3.649-3.648 1.272 1.272 0 0 1 .842-1.543 1.307 1.307 0 0 0 .491-2.175L4.256.368a1.4 1.4 0 0 0-1.895 0L1.028 1.7c-1.333 1.4.14 5.123 3.439 8.421s7.017 4.842 8.421 3.439l1.333-1.333a1.4 1.4 0 0 0 0-1.894z",
    transform: "translate(8.367 8.891)",
    style: {
      fill: "#1b74e4"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.53fc6d4b0adb60ee815f05762c1e5f85.svg";
export { ForwardRef as ReactComponent };